import validator from 'validator'
import isEmpty from 'validator/lib/isEmpty'
import isNumeric from 'validator/lib/isNumeric'
import isAlpha from 'validator/lib/isAlpha'
import isAlphanumeric from 'validator/lib/isAlphanumeric'
import isDecimal from 'validator/lib/isDecimal'
import isEmail from 'validator/lib/isEmail'
import isInt from 'validator/lib/isInt'

export const checkDecimal = (value) => {
  const regExp = /^(?:\d{1,3}(?:,\d{3})*|\d+)(?:\.\d+)?$/
  return regExp.test(value)
}

export const convertDecimalToInteger = (value) => {
  return Math.floor(value.replace(/\,/g,''))
}

const validations = Object.assign({}, {
  isNotEmpty: {
    rule: value => {
      return !isEmpty(value.trim())
    },
    hint: value => {
      return ['Required']
    }
  },
  isNumeric: {
    rule: value => {
      return isNumeric(value)
    },
    hint: value => {
      return ['Please enter integers only without a comma']
    }
  },
  isAlpha: {
    rule: value => {
      return isAlpha(value)
    },
    hint: value => {
      return ['Please enter alpha characters']
    }
  },
  isAlphanumeric: {
    rule: value => {
      return isAlphanumeric(value)
    },
    hint: value => {
      return ['Please enter alphanumeric characters only']
    }
  },
  isDecimal: {
    rule: value => {
      return isDecimal(value)
    },
    hint: value => {
      return ['Please enter a valid decimal number']
    }
  },
  isEmail: {
    rule: value => {
      return isEmail(value)
    },
    hint: value => {
      return ['Please enter a correct email address']
    }
  },
  validUpliftLoadASD: {  // upliftLoadASD range 1 - 20000
    rule: value => {
      const x = checkDecimal(value) ? convertDecimalToInteger(value) : null
      if (x) {
        return x <= 20000 && x >= 1
      } else {
        return false
      }
    },
    hint: value => {
      return ['Uplift load must be (1 to 20,000) lb']
    }
  },
  isInt: {
    rule: value => {
      return isInt(value)
    },
    hint: value => {
      return ['Please enter integers only without a comma']
    }
  },
  validEmbedmentDepth: {
    rule: value => {
      const x = checkDecimal(value) ? value : null
      if (x) {
        return x <= 132 && x > 0
      } else {
        return false
      }
    },
    hint: value => {
      return ['Maximum hole depth using Threaded Rod or Rebar is 132"']
    }
  },
  validNumberInstallations: {
    rule: value => {
      const x = isInt(value) ? value : null
      if (x) {
        return x <= 99999 && x >= 1
      } else {
        return false
      }
    },
    hint: value => {
      return ['Please enter a number of installations between 1 and 99,999'] // Exceeded maximum number of installations
    }
  },
  validCrackDepth: {
    rule: value => {
      const x = checkDecimal(value) ? value : null
      if (x) {
        return x <= 16.0 && x >= 0.1
      } else {
        return false
      }
    },
    hint: value => {
      return ['Crack depth must be (0.1 to 16) in']
    }
  },
  validCrackLength: {
    rule: value => {
      // const x = checkDecimal(value) ? convertDecimalToInteger(value) : null
      const x = isInt(value) ? value : null
      if (x) {
        return x <= 99999 && x >= 1
      } else {
        return false
      }
    },
    hint: value => {
      return ['Crack length must be (1 to 99,999) ft']
    }
  }
})

const validatorWrapper = {

  validate: (methods, value) => {
    const errors = methods.reduce((summary, method) => {
      if (validations[method] && !validations[method].rule(value)) {
        return summary.concat(validations[method].hint(value))
      } else {
        return summary
      }
    }, [])

    return errors
  }
}

export default validatorWrapper
